export default "__VITE_ASSET__DkjFeaa1__"